"use strict";
// Imports all Kendo Cultures in use, must be imported in every Webpack entry point!
Object.defineProperty(exports, "__esModule", { value: true });
require("@progress/kendo-ui/js/cultures/kendo.culture.de.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.de-AT.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.de-CH.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.de-DE.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.de-LI.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.de-LU.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.en.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.en-GB.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.en-MY.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.en-SG.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.es.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.es-ES.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.es-MX.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.fr.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.hu.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.id.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.ii.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.it.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.ko.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.ko-KR.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.nl.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.pl.js");
require("@progress/kendo-ui/js/cultures/kendo.culture.ru.js");
